export enum STATUS {
  ERROR = 'error',
  IDLE = 'idle',
  READY = 'ready',
  RUNNING = 'running',
  SUCCESS = 'success',
}

export enum BOTICARIO_CYCLES_LENGTH {
  NOT_HAS_EXTENDED_CAPTATION = 1,
  HAS_EXTENDED_CAPTATION = 2,
}

export enum PRODUCT_DETAIL_VARIATION_TYPES {
  COLOR = 'color',
  VOLUME = 'volume',
}
